import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import axios from '@axios'

export default function usePropertypinList() {
  const toast = useToast()
  const refPropertipyListTable = ref(null)
  const isNearBySidebarActive = ref(false);
  const placeData = ref({});
  const tableColumns = [
    { key: 'id', label: 'ID', sortable: true, tdClass:'width-200'},
    { key: 'image',label: 'Image', sortable: false, tdClass:'width-300 p-1' },
    { key: 'name',label:'Name of property pin', sortable: true },
    { key: 'rate',label:'Rate', sortable: false },
    { key: 'price_sqm',label:'Avg Selling price/sqm', sortable: false },
    { key: 'rent_price_sqm',label:'Avg Rent price/sqm', sortable: false },
    { key: 'zone_name',label:'Zone', sortable: false },
    { key: 'bts_name',label:'BTS', sortable: false },
    { key: 'mrt_name',label:'MRT', sortable: false },
    { key: 'airport_name',label:'Airport Link', sortable: false },
    { key: 'is_active',label:'Active', sortable: false },
    { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalPins = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusPin = ref(null)
  const filterId = ref(router.currentRoute.query.byID || null)
  const filterName = ref(router.currentRoute.query.keyword || null)
  const filterRate = ref(router.currentRoute.query.byRating || null)
  const BTSData = ref([])
  const MRTData = ref([])
  const AirportLinkData = ref([])
  const zoneData = ref([])
  const TagsData = ref([])
  const selectedZoneId = ref(router.currentRoute.query.byZone || null)
  const selectedBTSId = ref(router.currentRoute.query.byBTS || null)
  const selectedMRTId = ref(router.currentRoute.query.byMRT || null)
  const selectedAirportlinkId = ref(router.currentRoute.query.byAirportlink || null)
  const selectedTagsId = ref(router.currentRoute.query.byTags ? router.currentRoute.query.byTags.split(',') : [])

  const dataMeta = computed(() => {
  const localItemsCount = refPropertipyListTable.value ? refPropertipyListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalPins.value,
    }
  })

  const refetchData = () => {
    refPropertipyListTable.value.refresh()
  }

  watch([currentPage, perPage], () => {
    refetchData()
  })

  const fetchBts = async () => {
    try {
      const { data } = await store.dispatch('app-propertypin/fetchTransit', {
        type_code: "bts"
      })

      BTSData.value = data.data
    } catch(error){
      toast({
        component: ToastificationContent,
        props: {
          title: "Error fetching BTS' list",
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    }
  }

  const fetchMrt = async () => {
    try {
      const { data } = await store.dispatch('app-propertypin/fetchTransit', {
        type_code: "mrt"
      })

      MRTData.value = data.data
    } catch(error){
      toast({
        component: ToastificationContent,
        props: {
          title: "Error fetching MRT' list",
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    }
  }

  const fetchAirportLink = async () => {
    try {
      const { data } = await store.dispatch('app-propertypin/fetchTransit', {
        type_code: "airport"
      })

      AirportLinkData.value = data.data
    } catch(error){
      toast({
        component: ToastificationContent,
        props: {
          title: "Error fetching Airport Link' list",
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    }
  }

  const fetchZone = async () => {
    try {
      const { data } = await store.dispatch('app-propertypin/fetchZone', {
        // keywords: ""
      })

      zoneData.value = data.data
    } catch(error){
      toast({
        component: ToastificationContent,
        props: {
          title: "Error fetching Zone' list",
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    }
  }

  const fetchTags = async () => {
    try {
      const { data } = await axios.post('tags/v1/get', {
        perpage: 1000,
        offset: 0,
        is_active: 1,
      })

      TagsData.value = data.data
    } catch(error){
      toast({
        component: ToastificationContent,
        props: {
          title: "Error fetching Tags' list",
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    }
  }

  const deleteData = (id) => {
    store.dispatch('app-propertypin/fetchDeletePlace',id).then(response=>{
      toast({
        component: ToastificationContent,
        props: {
          title: "Delete Success",
          icon: 'AlertTriangleIcon',
          variant: 'success',
        },
      })

      refetchData();
    }).catch(error=>{
      toast({
        component: ToastificationContent,
        props: {
          title: "Error Delete Property",
          // API บอกเหตุผลที่ลบไม่ได้ไว้ใน body เช่น ยังมีห้องผูกกับ place นี้อยู่
          text: error && error.response && error.response.data ? error.response.data.message : undefined,
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    })
  }

  const fetchPropertypins = (ctx, callback)=>{
    const offset = perPage.value*(currentPage.value-1);
      store
      .dispatch('app-propertypin/fetchPropertitypin', {
        perpage: perPage.value,
        offset:offset,
        keyword:filterName.value,
        byID:filterId.value,
        byRating:filterRate.value,
        byZone: selectedZoneId.value,
        byBTS: selectedBTSId.value,
        byMRT: selectedMRTId.value,
        byAirportlink: selectedAirportlinkId.value,
        byTags: selectedTagsId.value,
        order_by: "ID DESC"
      })
      .then(response => {
        const properties = response.data.data;
        callback(properties)
        totalPins.value = response.data.total

        let queryURL = {}
        if(perPage.value) queryURL.perPage = perPage.value
        if(filterName.value) queryURL.keyword = filterName.value
        if(filterId.value) queryURL.byID = filterId.value
        if(filterRate.value) queryURL.byRating = filterRate.value
        if(selectedZoneId.value) queryURL.byZone = selectedZoneId.value
        if(selectedBTSId.value) queryURL.byBTS = selectedBTSId.value
        if(selectedMRTId.value) queryURL.byMRT = selectedMRTId.value
        if(selectedAirportlinkId.value) queryURL.byAirportlink = selectedAirportlinkId.value
        if(selectedTagsId.value && selectedTagsId.value.length) queryURL.byTags = selectedTagsId.value.join(',')

        const currentQuery = router.currentRoute.query;
        const newQueryString = new URLSearchParams(queryURL).toString();

        if (newQueryString !== new URLSearchParams(currentQuery).toString()) {
          router.replace({ query: queryURL });
        }
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching invoices' list",
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const applyFilter = (payload) => {
    filterId.value = payload.byID || null
    filterName.value = payload.keyword || null
    filterRate.value = payload.byRating || null
    selectedZoneId.value = payload.byZone || null
    selectedBTSId.value = payload.byBTS || null
    selectedMRTId.value = payload.byMRT || null
    selectedAirportlinkId.value = payload.byAirportlink || null
    selectedTagsId.value = payload.byTags || []
    currentPage.value = 1
    refetchData()
  }

  const clearFilter = () => {
    filterId.value = null
    filterName.value = null
    filterRate.value = null
    selectedZoneId.value = null
    selectedBTSId.value = null
    selectedMRTId.value = null
    selectedAirportlinkId.value = null
    selectedTagsId.value = []
    currentPage.value = 1
    refetchData()
  }

const popopNearBy = (place)=>{
  placeData.value = place;
  isNearBySidebarActive.value = true;

}
  return {
    fetchPropertypins,
    fetchBts,
    tableColumns,
    perPage,
    currentPage,
    totalPins,
    dataMeta,
    perPageOptions,
    sortBy,
    isSortDirDesc,
    refPropertipyListTable,
    statusPin,
    filterId,
    filterName,
    filterRate,
    deleteData,
    refetchData,
    BTSData,
    MRTData,
    fetchMrt,
    AirportLinkData,
    fetchAirportLink,
    fetchZone,
    zoneData,
    TagsData,
    fetchTags,
    selectedZoneId,
    selectedBTSId,
    selectedMRTId,
    selectedAirportlinkId,
    selectedTagsId,
    isNearBySidebarActive,
    popopNearBy,
    placeData,
    applyFilter,
    clearFilter,
  }
}
